import React from 'react'
import { Modal } from '../../../map-editor-shared/ui/Modal'

interface ErrorModalProps {
  isOpen: boolean
  onClose: () => void
  message: string
}

/**
 * ErrorModal - 에러 메시지 표시 모달
 *
 * 시스템 에러나 사용자 입력 오류 등을 표시하는 범용 에러 모달
 */
export const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose, message }) => {
  return (
    <Modal
      isOpen={isOpen}
      title="오류 발생"
      onClose={onClose}
    >
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div
          style={{
            width: '48px',
            height: '48px',
            background: 'rgba(239, 68, 68, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px auto',
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef4444"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <p style={{ marginBottom: '24px', color: '#e2e8f0', whiteSpace: 'pre-wrap' }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            padding: '8px 16px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          확인
        </button>
      </div>
    </Modal>
  )
}
